// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, setLogLevel } from "firebase/firestore"; // 👈 Importe setLogLevel aqui
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions'; 


const firebaseConfig = {
  apiKey: "AIzaSyDtYwNnW3e0DEcU5j_FI5gAKOxx6Ge2AUg",
  authDomain: "hubgestao1.firebaseapp.com",
  projectId: "hubgestao1",
  storageBucket: "hubgestao1.firebasestorage.app",
  messagingSenderId: "350158766938",
  appId: "1:350158766938:web:e64e440cef4ec4dcd1a963",
  measurementId: "G-C4FKQ185GH"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'southamerica-east1'); // Inicialize na região correta


// 👇 Adicione esta linha para definir o nível de log do Firestore
// Opções: 'debug', 'verbose', 'info', 'warn', 'error', 'silent'
// 'warn' mostrará apenas avisos e erros.
// 'error' mostrará apenas erros.
// 'silent' não mostrará nada do Firestore no console.
setLogLevel('error'); // 'warn' é um bom padrão para não poluir o console

export { auth, provider, db, storage, functions };